import request from '@/utils/request'

//获取完成到哪一步
export const getComplete = (data) => {
    return request.get('/api/evaluation/getComplete', data)
}
//保存完成哪一步
export const saveComplete = (data) => {
    return request.post('/api/evaluation/saveComplete', data)
}

// 今日开标列表-获取评标室信息
export const getEvaluationRoomList = (data) => {
    return request.get('/api/evaluation/getEvaluationRoomList',data)
}
// 专家登录接口
export const expertLogin = (data) => {
    return request.post('/api/evaluation/login', data)
}
//专家登录后获取投标人列表
export const getBidderList = (data) => {
    return request.get('/api/evaluation/login/bidder/list', data)
}
//根据userId和标段编码，获取投标文件
export const getBidderFile = (data) => {
    return request.post('/api/file/bid/main', data)
}
// 获取评标室专家列表
export const getEvaluationExpertList = (committeeId) => {
    return request.get('/api/evaluation/getHaveLoginExpertList?committeeId=' + committeeId)
}
//投票
export const getVoteBidder = (data) => {
    return request.post('/api/evaluation/vote', data)
}

//获取投票结果详情
export const getVoteResult = (data) => {
    return request.get('/api/evaluation/getVoteResult', data)
}

//根据id获取专家信息
export const getExpertById = (expertId) => {
    return request.get('/api/evaluation/getExpertById?expertId=' + expertId)
}

//获取评标室下的标段列表-招标列表接口
export const getCommitteeSectionList = (committeeId) => {
    return request.get('/api/evaluation/getCommitteeSectionList?committeeId=' + committeeId)

}
// 澄清
export const saveClarify = (data) => {
    return request.post('/api/evaluation/saveClarify', data)
}
//获取专家信息
export const getEvaluationInfo = () => {
    return request.get('/api/evaluation/login/info')
}
//根据项目编号和用户ID获取标段下投标文件目录
export const getBidCatalogue = (data) => {
    return request.post('/api/file/bid/catalogue', data)
}
//获取补遗内容
export const getEvaluationAgentContent = (id) => {
    return request.get('/api/evaluation/agent/content?id=' + id)
}
//终止流程
export const terminate = (data) => {
    return request.post('/api/evaluation/terminate', data)
}
//评委组长-二次报价配置列表
export const getOfferConfigList = (sectionCode) => {
    return request.get('/api/evaluation/offer/config/list?sectionCode=' + sectionCode)
}
//评委组长 - 二次报价 提交
export const saveOfferConfig = (data) => {
    return request.post('/api/evaluation/offer/config', data)
}
//评委组长 - 二次报价废除
export const invalidOffers = (data) => {
    return request.post('/api/evaluation/offer/invalid', data)
}

//二次报价废除某个单位
export const invalidOffersGet = (data) => {
    return request.post('/api/evaluation/invalid', data)
}

//根据标段编码获取投标单位
export const getDecryptCompanyList = (sectionCode) => {
    return request.get('/api/evaluation/getDecryptCompanyList?sectionCode=' + sectionCode)
}



//获取澄清列表
export const getClarifyList = (sectionCode, data) => {
    return request.get('/api/evaluation/getClarifyList?sectionCode=' + sectionCode, data)
}
// 澄清回复
export const replyClarify = (data) => {
    return request.post('/api/evaluation/getClarifyList/reply', data)
}
// 获取步骤列表
export const getStepList = (sectionCode) => {
    return request.get('/api/evaluation/getStepList?sectionCode=' + sectionCode)
}



/**
 * 
 * 评审相关
 * */

// 通过式评审项信息
export const getStepPassInfo = (data) => {
    return request.post('/api/step/pass/info', data)
}

//评审生效列表
export const postStepPassInfoList = (data) => {
    return request.post('/api/step/pass/info/list', data)
}
//保存通过式评审结果（评审生效）
export const saveStepPassInfo = (data) => {
    return request.post('/api/step/pass/all/save', data)
}
//创建评审记录
export const createStepRecord = (data) => {
    return request.post('/api/step/record', data)
}
//步骤提交接口
export const submitStep = (data) => {
    return request.post('/api/step/submit', data)
}
//保存通过式评审结果（单步骤）
export const saveStepPassInfoPer = (data) => {
    return request.post('/api/step/pass/per/save', data)
}
// 获取打分项规则明细
export const getStepScoreRule = (data) => {
    return request.get('/api/step/score/rule', data)
}
//获取打分项信息
export const getStepScoreInfo = (data) => {
    return request.post('/api/step/score/info', data)
}
//存通打分评审结果（单步骤）
export const saveStepScoreInfoPer = (data) => {
    return request.post('/api/step/score/per/save', data)
}
//打分信息（全部）
export const getStepScoreInfoList = (data) => {
    return request.post('/api/step/score/info/list', data)
}
//提交接口
export const submitStepScore = (data) => {
    return request.post('/api/step/score/submit', data)
}
//保存通过式评审结果（全部）
export const saveStepScoreInfoAll = (data) => {
    return request.post('/api/step/score/all/save', data)
}
//小微企业列表接口
export const getStepMesList = (data) => {
    return request.get('/api/step/mse/list', data)
}
//小微企业优惠保存
export const saveStepMse = (data) => {
    return request.post('/api/step/mse/save', data)
}
// 获取报价得分列表
export const getStepQuotationList = (data) => {
    return request.post('/api/step/quotation/list', data)
}
//计算报价得分列表
export const calculateStepQuotation = (data) => {
    return request.post('/api/step/quotation/calculate', data)
}
//手动输入报价得分
export const inputStepQuotation = (data) => {
    return request.post('/api/step/quotation/input', data)
}
// 基准价相关

// 获取基准价计算规则描述
export const getBasePriceDes = (data) => {
    return request.get('/api/evaluation/getCalBasePriceDetailInfo', data)
}
//保存基准价
export const saveBasePrice = (data) => {
    return request.post('/api/evaluation/basePriceSave', data)
}
//获取中标候选人列表
export const getRecommendList = (data) => {
    return request.post('/api/step/recommend/list', data)
}
//基准价计算
export const calculateBasePrice = (data) => {
    return request.post('/api/evaluation/calculateBasePrice', data)
}
// 更新候选人排名
export const rankUpdate = (data) => {
    return request.post('/api/step/recommend/rank/update', data)
}

//获取推送平台列表
export const getPushPlatformList = () => {
    return request.get('/api/evaluation/getPushPlatformList')
}

//专家阅读协议
export const read = (data) => {
    return request.get('/api/evaluation/read', data)
}



//专家证书列表
export const getExpertCertList = () => {
    return request.get('/api/ca/expert/cert/list')
}
// 专家CA签字
export const expertSign = (data) => {
    return request.post('/api/ca/expert/sign', data)
}

//查看报告文件
export const getReportFile = (sectionCode) => {
    return request.get('/api/evaluation/report/file?sectionCode='+sectionCode)
}


// 评标结束查询
//evaluationStatus = 0 未开始 1:评标中 2:已结束
export const evaluationEndQuery = (sectionCode) => {
    return request.get('/api/evaluation/record?sectionCode='+sectionCode)
}
//评标结束操作
export const evaluationEndUpdate = (sectionCode) => {
    return request.get('/api/evaluation/record/update?sectionCode='+sectionCode)
}































